import { environment } from "./environment.base";
export { environment };

environment.name = 'buckley';
environment.parentUrl =  'https://buckley.strayos.com';
environment.baseUrl = 'https://buckleydashboards.strayos.com';
environment.apiUrl = 'https://db.strayos.com';